<template>
	<div class="business">
		<base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
      :buttons="banner.buttons"
		>
		</base-banner>

		<base-goto :breadcrumbs="breadcrumbs"></base-goto>

    <div id="content">
      <quote-section></quote-section>

      <partner-section></partner-section>

      <div id="testimonial" class="sec">
				<v-container>
					<base-title
						title="What our partners are saying"
						size="1"
					></base-title>

					<v-row justify="center" :class="MIXIN_SETUP_UI.defaultSidePadding">
						<v-col
              cols="12" sm="6" md="6" lg="6" xl="6"
              v-for="(tes, key) in testimonials"
              :key="key"
              class="d-flex"
            >
							<testimonial-card
								:title="tes.title"
								:description="tes.caption"
								:ratings="tes.ratings"
								:name="tes.name"
							></testimonial-card>
						</v-col>
					</v-row>
				</v-container>
			</div>
    </div>
  </div>
</template>

<script>
import TestimonialCard from "@/components/home/TestimonialCard.vue";
import QuoteSection from "@/components/business/QuoteSection.vue";
import PartnerSection from "@/components/business/PartnerSection.vue";

import Repository from "@/api/repositories";
const BusinessBannersApi = Repository.get("businessBanners");
const BusinessTestimonialsApi = Repository.get("businessTestimonials");

export default {
  name: "Business",
  components: {
    TestimonialCard,
    QuoteSection,
    PartnerSection
  },
  data() {
    return {
      banner: [],
      testimonials: [],
      fields: [
        {
          item: "Your Name"
        },
        {
          item: "Designation"
        },
        {
          item: "Email Address"
        },
        {
          item: "Contact Number"
        },
        {
          item: "Company Name"
        },
        {
          item: "Nature of Business"
        },
        {
          label: "Total number of employees",
          item: [
            "Item 1",
            "Item 2",
            "Item 3"
          ]
        },
        {
          label: "Total number of dependents",
          item: [
            "Item 1",
            "Item 2",
            "Item 3"
          ]
        }
      ],
      breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
        {
					name: "Business",
					link: "/business",
					active: true
				},
			]
		}
  },
  async mounted() {
    this.getBusinessTestimonials();
    await this.getBusinessBanner();
    this.setHeaderColor();
  },
  methods: {
    setHeaderColor() {
      if (this.banner.backgroundColor)
        this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
      else
        this.$store.commit('page/defaultHeaderColor')
    },
    async getBusinessBanner() {
      try {
        const { data } = await BusinessBannersApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });
          
          let apiData = data.data[0];

          let buttons = apiData.buttons.map(button => {
            return {
              name: button.label,
              icon: button.image,
              link: button.redirect,
              color: JSON.parse(button.styling).color
            }
          });

          let banner = {
            buttons: buttons,
            image: apiData.background_image.main,
            caption: apiData.caption,
            title: apiData.title,
            titleColor: apiData.styles.titleColor,
            captionColor: apiData.styles.captionColor,
            backgroundColor: apiData.styles.backgroundColor
          }

          this.banner = banner;
        }

        console.log('[business-banner]', data, this.banner);
      }
      catch(error) {
        console.log(error);
      }
    },
    async getBusinessTestimonials() {
      try {
        const { data } = await BusinessTestimonialsApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });
          
          let testimonials = data.data.map(tes => {
            return {
              name: tes.name,
              title: tes.title,
              ratings: parseInt(tes.ratings),
              caption: tes.caption
            }
          });

          this.testimonials = testimonials;
        }

        console.log('[business-testimonials]', data, this.testimonials);
      }
      catch(error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

#testimonial {
  background: url('~@/assets/images/backgrounds/trans_map.png') 50% 104% / contain no-repeat;;
  background-color: white;
}
</style>